<template>
    <div class="page">
        <!-- if collection page - mobile description -->
        <div class="catalog">
            <h1 class="text_13 catalog__title" style="display: none">
                {{ this.isPages ? this.getPagesName : pageTitle }}
            </h1>
            <div class="description" v-if="collection && !$device.isDesktop && collection.description">
                <div class="catalog__description text_11" :class="{ is_open: isShowFullDescription }">
                    <div class="catalog__description-wrpp" :style="`min-height: ${currentDescriptionHeight}px`">
                        <div
                            class="catalog__description-text"
                            v-if="collection.description"
                            v-html="$options.filters.truncate(this.collection.description, 160)"></div>
                        <div class="catalog__description-full" v-if="collection.description">
                            <div class="catalog__description-full-text" v-html="collection.description"></div>
                        </div>
                    </div>
                    <div class="catalog__description-footer">
                        <div
                            class="catalog__description-toggler color-text_3"
                            @click="isShowFullDescription = !isShowFullDescription"
                            v-html="isShowFullDescription ? $i18n.t('hide') : $i18n.t('item_more')"></div>
                        <div class="catalog__description-sign" v-if="isShowFullDescription">{{ $t("slogan") }}</div>
                    </div>
                </div>
            </div>
            <CatalogFilter
                v-if="!mimicry"
                :data="{ filters: filters, items: catalogData.items, filter: filter }"
                :isCategoryPage="false"
                :isFilterCleared="isFilterCleared"
                :api-route="apiRoute"
                @update:isFilterCleared="isFilterCleared = false"
                @update:filter="updateItems($event)" />

            <div class="container catalog-categories-wrapper">
                <div class="catalog-categories text_11">
                    <swiper :options="sliderOptions">
                        <swiper-slide v-for="category in currentMenuItem?.items" :key="category.url">
                            <nuxt-link
                                :class="{ 'catalog-categories__current': category.url.includes(firstFilterCategory) }"
                                :to="category.url"
                                >{{ category.title }}</nuxt-link
                            >
                        </swiper-slide>
                    </swiper>
                </div>
            </div>

            <div class="catalog-items-block">
                <div class="row grid-row row--fullwidth">
                    <div
                        class="col col--description lg-4 sm-12 col--no-padding"
                        v-if="collection && $device.isDesktop && collection.description">
                        <div class="catalog__description text_11">
                            <h1 class="text_13 text_13--sm-11">{{ collection.site_name }}</h1>
                            <div v-if="collection.description" v-html="collection.description"></div>
                            <div class="catalog__description-sign">{{ $t("slogan") }}</div>
                        </div>
                    </div>
                    <template v-if="catalogData.items.length > 0">
                        <template v-for="(product, p_index) in catalogData.items">
                            <div
                                v-if="properBanners[p_index]"
                                class="col lg-12 col--no-padding"
                                :key="`banner-${product.id}`">
                                <ProductBanner
                                    v-for="(block, b_index) in properBanners[p_index]"
                                    :key="`${p_index}-${b_index}`"
                                    :block="block"></ProductBanner>
                            </div>
                            <div class="col lg-3 sm-6 col--no-padding" :key="product.id">
                                <Product
                                    :data="product"
                                    :index="p_index + 1"
                                    @update:showProductDetails="doMimicry($event)"
                                    :openInModal="true"></Product>
                            </div>
                            <div
                                class="col lg-3 sm-6 col--no-padding category-video"
                                :key="'video ' + p_index"
                                v-if="getVideo(p_index)"
                                :style="
                                    getVideo(p_index).poster
                                        ? `background:url(${$img.resizeSimple(
                                              getVideo(p_index).poster.path,
                                              475,
                                              713
                                          )}) center / cover`
                                        : ``
                                ">
                                <VideoBlock
                                    v-if="getVideo(p_index).mp4 || getVideo(p_index).webm"
                                    v-lazy-load :data-poster="
                                        getVideo(p_index).poster
                                            ? $img.resizeSimple(getVideo(p_index).poster.path, 475, 713)
                                            : ''
                                    "
                                    :mp4="getVideo(p_index).mp4 ? getVideo(p_index).mp4.path : false"
                                    :webm="getVideo(p_index).webm ? getVideo(p_index).webm.path : false"></VideoBlock>
                            </div>
                        </template>
                    </template>
                    <template v-else-if="!isGiftPage">
                        <div
                            class="no-products tac col sm-12 col--no-padding text_11"
                            :class="isCollectionPage ? 'lg-8' : 'lg-12'">
                            <div class="color-text_2">{{ $t("filter_empty") }}</div>
                            <div class="like-link" @click="isFilterCleared = true">{{ $t("filter_clear_filter") }}</div>
                        </div>
                    </template>
                </div>
                <client-only>
                    <mugen-scroll :handler="() => loadMore()" :should-handle="true">
                        <div class="inline-loader" v-if="catalogData.loading"></div>
                    </mugen-scroll>
                </client-only>
            </div>
        </div>
        <div v-if="isGiftPage" class="page-gifts">
            <GiftPage as-component></GiftPage>
        </div>

        <LastViewed v-if="isCategoryPage"></LastViewed>
        <!--        <EnRecom v-if="isCatPage && $i18n.locale === 'ru'"></EnRecom>-->
        <transition name="fade-in-left">
            <div class="productModal" v-if="productModal" v-bsl="!!productModal">
                <productPageComponent
                    is-modal
                    :gender="isAgenderPage ? 'all' : gender"
                    @modalClose="resetView()"
                    @update:product="$store.commit('catalog/updateProductModalProduct', $event)"
                    :product="productModal.product"></productPageComponent>
            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import CatalogFilter from "@/components/Filter";
import LastViewed from "@/components/LastViewed";
import Product from "../../components/Product.vue";
import ProductBanner from "@/components/product-blocks/Banner.vue";
import GiftPage from "../gift-card.vue";
import { Swiper, SwiperSlide } from "@/plugins/swiper.client";

import("@/assets/less/catalog.less");
export default {
    name: "CatalogPage",
    components: {
        Product,
        CatalogFilter,
        LastViewed,
        GiftPage,
        ProductBanner,
        Swiper,
        SwiperSlide,
        productPageComponent: () => import("@/components/ProductPage.vue"),
    },
    head() {
        const meta = [
            {
                hid: "description",
                name: "description",
                content: this.$i18n.t("cat_page_desc"),
            },
            {
                hid: "og:description",
                property: "og:description",
                content: this.$i18n.t("cat_page_desc"),
            },
        ];

        if (this.isSecretSale) {
            meta.push({
                hid: "robots",
                name: "robots",
                content: "noindex",
            });
        }

        return {
            title: this.pageTitle,
            meta,
        };
    },
    async asyncData({ $axios, redirect, route, store, from }) {
        store.commit("catalog/updateProductModal", null);

        let apiRoute = "skus/all";
        /**
         * для подарков страница в админке с ключом giftideas
         * но логика работы такая же как у open-sale
         */
        const isGiftPage = route.fullPath.includes("/giftideas");

        const isGiftPageActive = store.state.pages.list.find((p) => p.key === "giftideas" && p.is_active);
        const isSecretSalePageActive = store.state.pages.list.find((p) => p.key === "secret_sale" && p.is_active);

        /**
         * закрытый дроп сделали через закрытую распродажу
         */
        const isSecretSale = ["secret-sale", "drop-piercing"].includes(route.name);

        const isOpenSale = route.name === `open-sale` || isGiftPage;
        if (isSecretSale) apiRoute = `secret-sale/skus`;
        if (isOpenSale) apiRoute = `open-sale/skus`;

        // если это страница open_sale, которая нынче 04,03,2026 по задаче №8295
        // и сама страница open_sale активна - выводим товары (подарки) и блок с подарочной картой
        // страница open_sale тепрь страница с идеями для подарков

        if ((isSecretSale && !isSecretSalePageActive) || (isGiftPage && !isGiftPageActive)) {
            redirect("/404");
        }

        const fromWOPage =
            from?.path
                .split("/")
                .filter((s) => !s.includes("page="))
                .join("/") || "";

        const routeWOPage = route.path
            .split("/")
            .filter((s) => !s.includes("page="))
            .join("/");

        if (!store.getters["catalog/getNeedUpdateCatalog"] && fromWOPage === routeWOPage) {
            store.commit("catalog/updateNeedUpdateCatalog", true);
            return;
        }

        let gender = "woman";
        if (isSecretSale || isOpenSale) {
            gender = route.query.gender || "woman";
        }
        if (["catalog-man", "catalog-man-all", "man-gift-ideas"].includes(route.name)) {
            gender = "man";
        }

        const isFullCatalog = route.path === `/${gender}/` || isSecretSale || isOpenSale;

        let banners = [];

        try {
            if (isFullCatalog) {
                // забираем баннеры мужского или женского
                if (route.path === `/${gender}/`) {
                    if (gender === "woman") {
                        banners = store.getters["globalvars/getProductBlocksForWomanCatalog"];
                    } else {
                        banners = store.getters["globalvars/getProductBlocksForManCatalog"];
                    }
                }
                // все товары и все фильтры всех коллекций

                const items = await $axios.$get(
                    `/api/${apiRoute}?page=1&gender=${gender}${isOpenSale ? "&open_sale=1" : ""}`
                );
                return {
                    apiRoute,
                    gender,
                    catalogData: {
                        items: items.skus,
                        videos: null,
                        allowLoad: true,
                        loading: false,
                        page: 1,
                    },
                    filters: items.filter_values,
                    filter: {},
                    collection: null,
                    isSecretSale,
                    isOpenSale,
                    banners,
                    isFullCatalog,
                };
            } else {
                // /catalog/new|preorder|sale/collection=1,2/categories=1,2,3/color=5,6,7/size=45,56/season=3,4
                let filter = {
                    gender,
                };
                route.path
                    .toLowerCase()
                    .split("/")
                    .forEach((segment) => {
                        if (
                            segment &&
                            !["woman", "man", "gender", "catalog", "secret-sale", "sale", "drop-piercing"].includes(
                                segment
                            )
                        ) {
                            if (segment.includes("=")) {
                                let filterArr = segment.split("=");
                                if (filterArr[1]) {
                                    filter[filterArr[0]] = filterArr[1].split(",");
                                    if (filterArr[0] === "page") {
                                        filter[filterArr[0]] = Number(filterArr[1]);
                                    }
                                }
                            } else {
                                filter[segment] = 1;
                            }
                        }
                    });
                let collection;
                if (filter.collections && filter.collections.length === 1) {
                    try {
                        collection = await $axios.$get("/api/collections/" + filter.collections[0]);
                    } catch (error) {
                        delete filter.collections;
                    }
                }

                // проверяем на странице категории ли мы и ищем подходящие баннеры, соответсвующие этой категории
                const banners =
                    gender === "man"
                        ? store.getters["globalvars/getProductBlocksForManCategory"]
                        : store.getters["globalvars/getProductBlocksForWomanCategory"];
                const filteredBanners = banners.filter((b) =>
                    filter.categories.some((c) => b.categorySlugs.includes(c))
                );

                let page = store.state.pages.list.find((page) => page.key === Object.keys(filter)[0]) || null;

                if (page && !page.is_active) {
                    redirect("/404");
                }

                const requests = [
                    $axios.$get(`/api/skus/all`, {
                        params: filter,
                    }),
                ];

                if (filter.page > 1) {
                    const newFilter = Object.assign({}, filter);
                    newFilter.page = 1;
                    requests.push(
                        $axios.$get(`/api/skus/all`, {
                            params: newFilter,
                        })
                    );
                }

                const [items] = await Promise.all(requests);

                let videos = {};
                if (collection) {
                    collection.videos.forEach((video) => {
                        videos[video.sort_order] = video;
                    });
                }

                return {
                    apiRoute,
                    catalogData: {
                        items: items.skus,
                        videos: videos,
                        allowLoad: true,
                        loading: false,
                        page: filter.page || 1,
                    },
                    filters: items.filter_values,
                    filter: filter,
                    collection: collection || null,
                    gender,
                    isSecretSale,
                    banners: filteredBanners,
                    isFullCatalog: false,
                };
            }
        } catch (error) {
            console.log(`error =>`, error);
            // redirect("/404");
        }
    },
    data() {
        return {
            sliderOptions: {
                slidesPerView: "auto",
                freeMode: true,
                spaceBetween: 24,
            },
            isShowFullDescription: false,
            isFilterCleared: false,
            per_page: 6,
            leftCollections: [],
            mimicry: false,
            param: (() => {
                // Для /catalog и /catalog/ возвращаем пустую строку
                if (this.$route.path === `/${this.gender}/`) {
                    return "";
                }

                // Для других путей проверяем pathMatch
                const pathMatch = this.$route.params.pathMatch;
                if (!pathMatch) {
                    return "";
                }

                return pathMatch.endsWith("/") ? pathMatch.slice(0, -1) : pathMatch;
            })(),
        };
    },
    watch: {
        location(val) {
            if (val === this.$route.path) {
                this.mimicry = false;
                this.$store.commit("crumbs/change", this.crumbs);
            }
        },
        async langust(val, oldVal) {
            if (oldVal) {
                await this.$nuxt.refresh();
                this.loadMore();
                this.$store.commit("crumbs/change", this.crumbs);
            }
        },
        async isCollectionPage(val) {
            if (val && this.filter.collections[this.gender] && this.filter.collections[this.gender].length === 1) {
                this.collection = await this.getCollection(this.filter.collections[0]);
                this.leftCollections = this.collections[this.gender].filter((el) => el.slug !== this.collection.slug);
            } else {
                this.collection = null;
                this.leftCollections = [];
            }
            this.$store.commit("crumbs/change", this.crumbs);
        },
    },
    computed: {
        ...mapState("globalvars", ["bannerPlacement"]),
        ...mapGetters({
            collections: "collections/get",
            categories: "collections/getCategories",
            locale: "globalvars/getLocale",
            langust: "globalvars/getLang",
            pages: "pages/get",
            needUpdateCatalog: "store/getNeedUpdateCatalog",
            productModal: "catalog/getProductModal",
            mainMenu: "globalvars/getMainMenu",
        }),
        currentMenuItem() {
            // return this.categories[this.gender];
            const genderItems = this.mainMenu.find((el) => {
                return el.children?.left_top?.find((c_lt) => c_lt.url.startsWith(`/${this.gender}`));
            });
            const genderMenu = genderItems.children?.right || [];
            if (this.isFullCatalog && !this.isSecretSale && !this.isOpenSale) {
                return {
                    current: genderItems,
                    items: genderMenu,
                    parent: null,
                };
            }
            const findMenuContext = (items, path, parent = null) => {
                for (const item of items) {
                    // Текущий пункт найден
                    if (item.url && path.includes(item.url)) {
                        // У текущего пункта есть дети
                        if (item.children) {
                            const children = Array.isArray(item.children)
                                ? item.children
                                : Object.values(item.children).flat();

                            return {
                                current: item,
                                parent,
                                items: children,
                            };
                        }

                        // Детей нет — возвращаем соседей
                        return {
                            current: item,
                            parent,
                            items,
                        };
                    }

                    // Ищем глубже
                    if (item.children) {
                        const groups = Array.isArray(item.children) ? [item.children] : Object.values(item.children);

                        for (const group of groups) {
                            if (!Array.isArray(group)) {
                                continue;
                            }

                            const result = findMenuContext(group, path, item);

                            if (result) {
                                return result;
                            }
                        }
                    }
                }

                return null;
            };
            const result = findMenuContext(genderMenu, this.$route.path);

            return result;
        },
        firstFilterCategory() {
            const cats = this.filter.categories;
            if (cats) {
                return cats[0];
            }
            return null;
        },
        properBanners() {
            const deviceProductIndex = (row) => {
                if (process.client) {
                    return (window.matchMedia("screen and (max-width: 750px)").matches ? 2 : 3) * row;
                }
                return 3 * row;
            };
            const res = {};
            this.banners.forEach((b) => {
                let index = null;

                if (this.isFullCatalog) {
                    if (
                        this.gender === "woman" &&
                        (b.placement.includes(this.bannerPlacement.WOMAN_CATALOG) ||
                            b.placement.includes(this.bannerPlacement.EVERYWERE))
                    ) {
                        index = deviceProductIndex(b.womenCatalogRows);
                    }
                    if (
                        this.gender === "man" &&
                        (b.placement.includes(this.bannerPlacement.MAN_CATALOG) ||
                            b.placement.includes(this.bannerPlacement.EVERYWERE))
                    ) {
                        index = deviceProductIndex(b.menCatalogRows);
                    }
                } else {
                    if (
                        b.placement.includes(this.bannerPlacement.CATEGORY) ||
                        b.placement.includes(this.bannerPlacement.EVERYWERE)
                    ) {
                        index = deviceProductIndex(b.categoryRows);
                    }
                    if (
                        this.gender === "woman" &&
                        (b.placement.includes(this.bannerPlacement.WOMAN_CATEGORY) ||
                            b.placement.includes(this.bannerPlacement.EVERYWERE))
                    ) {
                        index = deviceProductIndex(b.womenCategoryRows);
                    }
                    if (
                        this.gender === "man" &&
                        (b.placement.includes(this.bannerPlacement.MAN_CATEGORY) ||
                            b.placement.includes(this.bannerPlacement.EVERYWERE))
                    ) {
                        index = deviceProductIndex(b.menCategoryRows);
                    }
                }

                if (!res[index]) {
                    res[index] = [];
                }
                res[index].push(b);
            });
            return res;
        },
        isAgenderPage() {
            return this.$route.path.includes("collections=agndr");
        },
        location() {
            return process.client ? window.location.href : "";
        },
        crumbs() {
            const res = [
                {
                    name: this.$i18n.t("cat"),
                    url: `/${this.gender}/`,
                },
            ];

            if (this.isSecretSale) {
                return [
                    {
                        name:
                            this.$route.name === "drop-piercing"
                                ? "piercing drop"
                                : this.$i18n.t("secret_sale_page_title"),
                    },
                ];
            }

            if (this.isCollectionPage || this.isPages) {
                return [
                    ...res,
                    {
                        name: this.isCollectionPage ? this.getCollectionName : this.getPagesName,
                    },
                ];
            }

            if (this.currentMenuItem?.parent) {
                res.push({
                    name: this.currentMenuItem.parent.title,
                    url: this.currentMenuItem.parent.url,
                });
            }

            if (this.isCategoryPage) {
                res.push({
                    name: this.getCategoryName,
                });

                return res;
            }

            if (this.currentMenuItem?.current) {
                res.push({
                    name: this.currentMenuItem.current.title,
                });
            }

            return res;
        },
        isCollectionPage() {
            return this.filter && this.filter.collections && this.filter.collections.length === 1;
        },
        isCategoryPage() {
            return this.filter && this.filter.categories && this.filter.categories.length === 1;
        },
        isPages() {
            return this.pages.map((item) => `${item.key}=1`).includes(this.param);
        },
        getPagesName() {
            return this.$i18n.t(this.pages.filter((item) => `${item.key}=1` === this.param)[0].key);
        },
        getCategoryName() {
            let param = this.param;
            let currentCollection = "";

            this.filters.categories.forEach(function (value) {
                if (value.slug === param.split("=")[1]) {
                    currentCollection = value.name;
                }
            });

            return currentCollection;
        },
        getCollectionName() {
            let param = this.param;
            let currentCollection = "";

            this.filters.collections.forEach(function (value) {
                if (value.slug === param.split("=")[1]) {
                    currentCollection = value.name;
                }
            });

            return currentCollection;
        },

        currentDescriptionHeight() {
            if (this.isShowFullDescription) {
                return document.querySelector(".catalog__description-full-text").offsetHeight;
            }
            return 0;
        },
        pageTitle() {
            if (this.isSecretSale) {
                return this.$i18n.t("secret_sale_page_title");
            }
            let res = this.collection ? this.collection.site_name : this.$i18n.t("cat");
            if (this.filter?.categories?.length === 1) {
                // если выбрана одна катгоерия забираем имя категории и выводим как заголовок страницы
                const check = this.filters?.categories.filter((el) => el.slug === this.filter?.categories[0]) || [];
                if (check.length) {
                    res = this.$i18n.t("buy") + " " + check[0].name + " " + this.$i18n.t("cat_page_title");
                }
            }
            return res;
        },
        isGiftPage() {
            return this.$route.fullPath.includes("giftideas");
        },
    },
    filters: {
        truncate(value, length, ellipsis = true) {
            if (!value) return "";
            value = value.toString();
            if (value.length > length) {
                return value.substring(0, length) + (ellipsis ? "..." : "");
            } else {
                return value;
            }
        },
    },
    methods: {
        ...mapMutations("catalog", ["updateProductModal"]),
        doMimicry(data) {
            this.mimicry = data.mimicry;
        },
        updateItems(res) {
            //scroll top
            if (process.client) window.scrollTo(0, 0);

            this.$grom.pushGTMshowProducts(res.items);

            this.catalogData.items = res.items;
            this.catalogData.allowLoad = true;
            this.catalogData.loading = false;
            this.catalogData.page = 1;

            this.filters = res.filters;
            this.filter = res.filter;
        },
        async loadMore() {
            if (!this.catalogData.allowLoad || this.catalogData.loading) {
                return;
            }

            this.catalogData.loading = true;
            this.catalogData.allowLoad = false;

            this.catalogData.page += 1;

            const params = { ...this.filter };
            params.page = this.catalogData.page;
            params.perpage = 6;
            params.gender = this.gender;

            const items = await this.$axios.$get(`/api/${this.apiRoute}`, {
                params: params,
            });

            // Добавляем новые товары в конец
            this.catalogData.items.push(...items.skus);
            this.catalogData.loading = false;

            if (items.pagination.current_page < items.pagination.last_page) {
                this.catalogData.allowLoad = true;
            }
        },
        getCollection(slug) {
            return this.$axios.$get("/api/collections/" + slug);
        },
        getVideo(video_index) {
            if (this.catalogData.videos) {
                let index = (video_index + 1) * 2;
                if (this.catalogData.videos[index]) {
                    return this.catalogData.videos[index];
                }
            }
            return false;
        },
        resetView() {
            this.mimicry = false;
            this.updateProductModal(null);
            this.$store.commit("crumbs/change", this.crumbs);
        },
    },
    created() {
        this.$nuxt.$on("update-location-href", this.resetView);
    },
    mounted() {
        this.$store.commit("crumbs/change", this.crumbs);
        this.$grom.pushGTMshowProducts(this.catalogData.items);
        if (this.isCollectionPage) {
            this.leftCollections = this.collections[this.gender].filter((el) => el.slug !== this.collection.slug);
        }

        window.addEventListener("popstate", this.resetView, false);

        this.catalogData.allowLoad = true;
    },
    // updated() {
    //     console.log(`updated =>`);
    //     if (this.$device.isMobile) {
    //         this.mimicry = false;
    //     }
    // },
    beforeDestroy() {
        window.removeEventListener("popstate", this.resetView, false);
    },
};
</script>
<style lang="less" scoped>
.infinite-loading-container {
    width: 100%;
}
.sub-header {
    @media @sm {
        z-index: 4;
        position: sticky !important;
        top: 37px;
        border-top: 0 !important;
        transform: none !important;
        background: @bg;
        .trs(top);
        // .is_scrolled & {
        //     top: 0;
        // }
        &.is_open {
            z-index: 5;
        }
    }
}
.fade-in-left-leave-active {
    .catalog__title {
        opacity: 0;
    }
}
.catalog {
    .catalog-items-block {
        .grid-row {
            gap: 1px;
            @media @sm {
                display: grid;
                &:before,
                &:after {
                    display: none !important;
                }
            }
        }
    }
    &__title {
        position: fixed;
        z-index: 6;
        left: 50%;
        transform: translateX(-50%);
        top: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        opacity: 1;
        .trs(all);
        // @media @notsm {
        //     .is_scrolled & {
        //         transform: translate(-50%, -100%);
        //     }
        // }
        @media @sm {
            position: static;
            width: 100%;
            transform: none;
            justify-content: center;
            border-bottom: 1px solid @border2;
            height: initial;
            padding: 0 7px 0 16px;
        }
    }
    &__description {
        line-height: 150%;
    }
}
.mugen-scroll {
    position: relative;
    height: 50px;
}

.catalog-categories {
    text-align: center;
    white-space: nowrap;
    padding: 10px 0;

    display: flex;
    justify-content: center;

    .swiper-slide {
        width: auto;
    }
    &__current {
        color: @red2;
        text-decoration: underline;
        text-underline-offset: 3px;
    }
    a {
        line-height: 16px;
    }
}
</style>
<style lang="less">
.catalog-categories {
    .swiper-container:not(.swiper-container-initialized) {
        .swiper-wrapper {
            display: flex;
            gap: 24px;
        }
    }
}
.catalog-categories-wrapper {
    border-bottom: 1px solid @border2;
    + .ps__rail-x {
        height: 3px;
        .ps__thumb-x {
            height: 2px;
        }
        &:hover {
            height: 6px;
            .ps__thumb-x {
                height: 4px;
            }
        }
    }
}
</style>
